enum CashBoxTransactionTypes {
  Deposit = 'deposit',
  Withdrawal = 'withdrawal',
}

export default CashBoxTransactionTypes;
